// @flow
import React from 'react';

import { Trans } from 'react-i18next';


type PaidTextProps = {
  paymentTo: string,
  isFree: boolean,
}

const PaidText = ({ paymentTo, isFree }: PaidTextProps) => (isFree
  ? <Trans i18nKey="subs:free_for" paymentTo={paymentTo}>
    Бесплатно по
    {{ paymentTo }}
  </Trans>
  : <Trans i18nKey="subs:paid_by" paymentTo={paymentTo}>
    Оплачено по
    {{ paymentTo }}
  </Trans>);

export default PaidText;
